// Polyfills for Node.js modules required by Web3 libraries
import process from 'process'
import { EventEmitter } from 'events'

const globalScope = typeof globalThis !== 'undefined' ? globalThis : undefined

if (typeof window !== 'undefined') {
  window.process = process
  window.global = window
}

if (globalScope) {
  globalScope.process = process
  globalScope.global = globalScope
}

/**
 * `buffer` is ~57KB and only web3/Magic code paths touch it, so it is installed
 * on demand instead of on the critical path. Idempotent; safe to await anywhere.
 */
let bufferPromise = null
export function ensureBufferPolyfill() {
  if (globalScope?.Buffer) return Promise.resolve(globalScope.Buffer)
  if (!bufferPromise) {
    bufferPromise = import('buffer').then(({ Buffer }) => {
      if (typeof window !== 'undefined') window.Buffer = Buffer
      if (globalScope) globalScope.Buffer = Buffer
      return Buffer
    })
  }
  return bufferPromise
}

/** Installs the Buffer global off the critical path, once the browser is idle. */
export function preloadBufferPolyfill() {
  if (typeof window === 'undefined') return
  const run = () => ensureBufferPolyfill()
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run, { timeout: 3000 })
  } else {
    setTimeout(run, 1000)
  }
}

export { process, EventEmitter }
